import { ReactNode } from 'react';

import { ProfAI } from '../agents/profai';

/**
 * Enumerating and validating screen names
 **/
export enum Tool {
  INIT = 'init', // before session has started
  PROFILE = 'profile', // gather user info
  OVERVIEW = 'overview', // self-assessment for the skill
  ASSESSMENT = 'assessment', // evaluate user competencies
  COMPETENCIES = 'competencies', // select competency to practice
  PLANNING = 'planning', // create practice plan
  EXERCISE = 'exercise', // perform the exercise
  REVIEW = 'review', // review the exercise
  RESULTS = 'results', // end of skill lesson
  DONE = 'done', // after session has ended
}

/**
 * For implementing a screen that can be used in the abstract coaching session
 **/
export interface ToolIface<Agent extends ProfAI = ProfAI> {
  init?: (agent: Agent) => void;
  prefetch?: (agent: Agent, payload?: any) => void;
  render: (agent: Agent) => ReactNode;
}

export function isTool(tool: Tool | unknown): tool is Tool {
  if (typeof tool !== 'string') return false;
  return Object.values(Tool).includes(tool as Tool);
}
